// extracted by mini-css-extract-plugin
export default {"mainFields":"PEjejB"};